import React from "react";
import { selectors } from "@Src/redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import { Creators } from "@Src/redux/actionTypes";
import { doFetch } from "@Src/api/apiFetchHelper";
import Loading from "@Components/loading";
import { VWO_NAV_COOKIE } from "@Src/constants";
import { setCookie } from "@Src/utils/cookie.utils";

const GetProgramInfo = ({ children }) => {
  const programKey = useSelector(selectors.getProgramKey);
  const dispatch = useDispatch();

  // "/api/init" inits the csrf tokens in stage/prod environments, then gets program info
  const initProgram = React.useCallback(() => {
    doFetch("/api/init").then(() => {
      dispatch(Creators.fetchingProgram());
    });
  }, [dispatch]);

  // get program info
  React.useEffect(() => {
    if (!programKey) {
      initProgram();
    }

    if (programKey) {
      programKey === "200614" && setCookie(VWO_NAV_COOKIE, 2);
    }
  }, [programKey, initProgram]);

  if (!programKey) {
    return <Loading />;
  }
  return children;
};

export default GetProgramInfo;
